export default class MediaPlayer {
  constructor(element) {
    this.el = element;
    this.videoID = this.el.dataset.videoid;
    this.videoPlayerContainer = this.el.querySelector(".video-container");
    this.videoPlay = this.el.querySelector(".play-button");
    this.videoImageOverlay = this.el.querySelector(".video-image-overlay");
    this.videoConsentFallback = this.el.querySelector(".video-consent-popup");
    this.youtubeThumbnail = this.el.querySelector(".youtube-thumbnail");

    this.player = null;
    this.controller = null;
    this.hasAccess = false;

    this.init();
  }

  init() {
    this.observeCookieConsent();

    if (this.hasConsent()) {      
      this.showPlayer();
    } else {
      this.showConsentUI();
    }
  }

hasConsent() { 
  const match = document.cookie.match(/CookieInformationConsent=([^;]+)/);
  if (!match) return false;
  try {
    const consentData = JSON.parse(decodeURIComponent(match[1]));
    return consentData.consents_approved?.includes('cookie_cat_marketing');
  } catch (e) {
    console.error("Failed to parse consent cookie:", e);
    return false;
  }
}


  observeCookieConsent() {
    if ('cookieStore' in window && 'onchange' in window.cookieStore) {
      window.cookieStore.addEventListener('change', () => {
        if (!this.hasAccess && this.hasConsent()){
          this.hasAccess = true;
          this.showPlayer();
        }else if (this.hasAccess && !this.hasConsent()) {
          this.hasAccess = false;
          this.showConsentUI();
        }
        //this.hasConsent() ? this.showPlayer() : this.showConsentUI();
      });
    } else {
      let lastConsent = this.hasConsent();
      setInterval(() => {
        const current = this.hasConsent();
        if (current !== lastConsent) {
          current ? this.showPlayer() : this.showConsentUI();
          lastConsent = current;
        }
      }, 1000);
    }
  }

showPlayer() {
  this.setConsentUIVisibility(false);

  const existingIframe = this.el.querySelector('iframe');
  if (existingIframe) existingIframe.remove();

  this.player?.destroy?.();
  this.player = null;

  this.shouldAutoplay = false; // default

  if (this.videoImageOverlay && this.videoPlay) {    
    this.videoPlay.addEventListener('click', () => {
      this.shouldAutoplay = true;
      this.loadVideo();
    }, { once: true });
  } else {  
    
    this.loadYouTubeAPI();
  }
}
  
  showConsentUI() {
    console.log('showConsentUI');
    this.setConsentUIVisibility(true);

    const iframe = this.el.querySelector('iframe');
    if (iframe) iframe.remove();
    
    this.player = null;
  }

  setConsentUIVisibility(show) {
    if (this.videoConsentFallback) {
      this.videoConsentFallback.style.setProperty('display', show ? 'flex' : 'none');
      this.videoConsentFallback.style.setProperty('opacity', show ? '1' : '0');
    }
    if (this.videoImageOverlay) {
      this.videoImageOverlay.style.setProperty('display', show ? 'none' : 'block');
      this.videoImageOverlay.style.setProperty('opacity', show ? '0' : '1');
    }
  }

  loadVideo() {
    this.videoImageOverlay.style.opacity = 0;
    this.videoImageOverlay.style.display = 'none';
    this.loadYouTubeAPI();
  }

 loadYouTubeAPI() {
  if (!this.videoID) {
    console.error("No video ID provided.");
    return;
  }

  // Use a global queue to handle multiple players
  if (!window._ytPlayerQueue) {
    window._ytPlayerQueue = [];
  }

  window._ytPlayerQueue.push(() => this.createPlayer());

  if (!this.isScriptLoaded()) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(tag);
    window.onYouTubeIframeAPIReady = function () {
      window._ytPlayerQueue.forEach(fn => fn());
      window._ytPlayerQueue = [];
    };
  } else if (window.YT && window.YT.Player) {
    // API already loaded
    this.createPlayer();
  }
}



createPlayer() {
  const containerId = 'player-' + this.videoID;
  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    container.classList.add('aspect-video', 'bg-black', 'absolute', 'top-0', 'left-0', 'w-full', 'h-auto', 'z-1');
    this.videoPlayerContainer.appendChild(container);
  }

  const self = this;
  const autoplaying = self.shouldAutoplay ? 1 : 0;

  this.player = new YT.Player(containerId, {
    height: '390',
    width: '640',
    videoId: this.videoID,
    playerVars: {
      'autoplay': autoplaying,
      'controls': 1,
    },
    
    host: 'https://www.youtube.com',
    events: {
      onReady: function () {
        if (self.shouldAutoplay) {
          self.player.playVideo();
        } else {
          console.log("Player ready, not autoplaying");
        }
      },
      onError: this.onPlayerError
    }
  }); 
}


  onPlayerError(event) {
    const messages = {
      2: "Invalid video ID.",
      5: "HTML5 error.",
      100: "Video not found.",
      101: "Embedding disabled.",
      150: "Embedding disabled."
    };
    console.error(`YouTube error (${event.data}): ${messages[event.data] || 'Unknown error'}`);
  }

  isScriptLoaded(url = "https://www.youtube.com/iframe_api") {
    return [...document.getElementsByTagName('script')].some(s => s.src === url);
  }
}